import React from "react";
import "../styles/TitleBar.css";

function TitleBar() {
  return (
    <section className="title-bar">
      <p>carlos_tavares_desenvolvedor jr</p>
      <div className="title-btn">
        <span className="close" />
        <span className="minimize" />
        <span className="maximize" />
      </div>
    </section>
  );
}

export default TitleBar;
